import type { LoginData } from '@indutrust/auth-model';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

/**
 * Login flow events for the authentication system.
 *
 * These events drive the reactive login process from credential submission
 * to successful authentication and user data retrieval.
 *
 * @example
 * const dispatch = injectDispatch(loginEvents);
 * dispatch.loginRequested({ email: 'user@example.com', password: 'secret' });
 */
export const loginEvents = eventGroup({
  source: 'auth.login',
  events: {
    loginRequested: type<LoginData>(),
    loginSucceeded: type<{
      accessToken: string;
    }>(),
    loginFailed: type<{
      error: string;
    }>(),
  },
});
